import React from "react";

import { ContentCard } from "@narmi/design_system";

interface StatCardProps {
  label: string;
  count: number;
  testId?: string;
}

const StatCard = ({ label, count, testId }: StatCardProps) => (
  <ContentCard kind="bordered" paddingSize="l" testId={testId}>
    <div className="fontColor--primary fontSize--m fontWeight--semibold">
      {label}
    </div>
    <div className="fontSize--heading1 fontWeight--bold margin--top--xs">
      {count.toLocaleString()}
    </div>
  </ContentCard>
);

export default StatCard;
